import { GridRow, mixins, styled } from '@bob/library'

export const StyledRow = styled(GridRow)`
  border-top: 2px solid ${mixins.colors.grayMid};
  ${mixins.padding(0, 0, 10)}
  ${mixins.media.min.tablet} {
    ${mixins.padding(30, 0, 40)}
  }

  &:last-child {
    border-bottom: 2px solid ${mixins.colors.grayMid};
  }
`
export const Header = styled.h3`
  ${mixins.typography.headlineSmall}
  ${mixins.media.max.phone} {
    ${mixins.margin.bottom(0)}
  }
`

export const Description = styled.div`
  width: 100%;
  ${mixins.margin(10, 0)};

  ${mixins.media.min.tablet} {
    ${mixins.margin(25, 0)};
  }

  & p {
    ${mixins.typography.paragraphMedium}
    font-weight: 400;
    color: ${mixins.colors.grayDark};
    ${mixins.margin(0)};
  }
`
export const ButtonTertiary = styled.a`
  ${mixins.cta.tertiary('blue')}
  ${mixins.padding.left(0)};
`
